import { storage } from './redux-storage';

export const authPersistConfig = {
    key: 'auth',
    storage,

    // blacklist delete field to persist
    blacklist: ['loading', 'error'],
};
